import * as React from 'react'
import { format } from 'date-fns'
import { da } from 'date-fns/locale'
import DatePickerButton from '../shared/DatePickerButton'

type DateNavigationProps = {
  date: Date
  holiday?: string | null
  onDateChange: (date: Date) => void
  onPrev: () => void
  onNext: () => void
}

export default function DateNavigation({ date, holiday, onDateChange, onNext, onPrev }: DateNavigationProps) {
  const formattedDate = format(date, 'eeee, PPP', { locale: da })
  let label = <span>{formattedDate}</span>
  if (holiday) {
    label = (
      <span>
        <span>{formattedDate}</span>
        <span className="text-danger ml-2">{holiday}</span>
      </span>
    )
  }

  return (
    <div className="datepicker-container">
      <div className="row">
        <div className="col d-flex justify-content-center">
          <button type="button" className="btn btn-outline-secondary" onClick={onPrev}>
            &lt;
          </button>
          <div className="col-8 ml-2 mr-2">
            <DatePickerButton
              buttonLabel={label}
              buttonClass="btn btn-outline-secondary w-100"
              date={date}
              setDate={onDateChange}
            />
          </div>
          <button type="button" className="btn btn-outline-secondary" onClick={onNext}>
            &gt;
          </button>
        </div>
      </div>
    </div>
  )
}

